import { storybookReady } from '../../../core/js/utils'

(async function() {
await storybookReady()

/**
 * https://atomiks.github.io
 */

let getContent = ref => {
  const trigger = ref.getAttribute('data-dialog-template')
  const container = document.createElement('div')
  const linkedTemplate = document.getElementById(trigger)
  const node = linkedTemplate && document.importNode(linkedTemplate.content, true)

  node && container.appendChild(node)

  return container
}

tippy('[data-dialog]', {
  trigger: 'click',
  theme: 'pitti',
  arrow: true,
  hideOnClick: true,
  interactive: true,
  size: 'large',
  distance: 0,
  maxWidth: 800,
  flipOnUpdate: true,
  content (reference) {
    const trigger = reference.getAttribute('data-dialog-template')
    const container = document.createElement('div')
    const linkedTemplate = document.getElementById(trigger)
    const node = linkedTemplate && document.importNode(linkedTemplate.content, true)

    node && container.appendChild(node)

    return container
  },
  onShown (instance) {
    const closeDialog = document.querySelector('[data-dialog-close]')
    closeDialog.addEventListener('click', () => {
      instance.hide()
    })

    var evt = new CustomEvent('dialogopened', { detail: { instance: instance } })
    window.dispatchEvent(evt)
  },
  onHidden (instance) {
    instance.setContent(getContent(instance.reference))
  },
  flip: false
})

})()
